import styled from 'styled-components';

type CastingContactInfoProps = {
  castingContact: string | null | undefined;
  castingPhone: string | null | undefined;
  castingEmail: string | null | undefined;
};
export const CastingContactInfo = ({
  castingContact,
  castingPhone,
  castingEmail,
}: CastingContactInfoProps) => {
  return (
    <StyledContainer>
      <div className='casting-contact-section-title'>Casting Contact</div>
      <div className='text-wrap-anywhere'>{castingContact || '-'}</div>
      {!!castingPhone && (
        <div className='text-wrap-anywhere'>{castingPhone}</div>
      )}
      {!!castingEmail && (
        <div className='text-wrap-anywhere'>{castingEmail}</div>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  line-height: 16px;

  .casting-contact-section-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
